// Last-resort screen shown when the app shell's own chunk cannot be loaded
// (offline, or a hard content/proxy block) even after retries. The app's normal
// error UI and i18n both live inside that shell, so this is deliberately static
// and untranslated — there is nothing loaded to translate against.
export default function BootFailure() {
  return (
    <div
      style={{
        fontFamily: "system-ui, sans-serif",
        maxWidth: 480,
        margin: "20vh auto",
        padding: "0 1rem",
        textAlign: "center",
        color: "#374151",
      }}
    >
      {/* eslint-disable-next-line i18next/no-literal-string -- boot fallback: i18n is unavailable when the app shell fails to load */}
      <p>We couldn’t load the application. Please check your connection and try again.</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{padding: "0.5rem 1rem", cursor: "pointer"}}
      >
        {/* eslint-disable-next-line i18next/no-literal-string -- boot fallback: i18n is unavailable when the app shell fails to load */}
        Reload
      </button>
    </div>
  );
}
